export enum ReturnCodeType {
  REGULAR = 'REGULAR',
  OPEN_HOURS = 'OPEN_HOURS',
}
